// Receivables & collections (admins + managers). AR aging, cash-flow forecast, per-client arrears.
import { api } from './client.js';

export const fetchReceivables = () => api.get('/receivables').then((r) => r.data);
